import { CharacterBase } from '../../game/characters/CharacterBase';
import { CharacterHero } from '../../game/characters/CharacterHero';

export class HeroPreviewer extends Phaser.GameObjects.Container {
  constructor(scene, heroid) {
    super(scene);
    scene.add.existing(this);
    this.isCanvas =
      scene.sys.game.config.renderType === Phaser.CANVAS ||
      (scene.sys.game.device.os.iOS && navigator.userAgent.includes('15.4'));
    // this.isCanvas = scene.sys.game.config.renderType === Phaser.CANVAS;
    this._sprite = new CharacterHero(scene, 0, -40, scene.game.model.getHeroConfig(heroid));
    this._sprite.depth = 1;

    if (!this.isCanvas) {
      this.maskImage = scene.add
        .image(0, 0, 'graphics', 'item_select_bg')
        .setOrigin(0.5, 1)
        .setVisible(false);
      // this.mask = this.maskImage.createBitmapMask();
      const mask = this.maskImage.createBitmapMask();
      this._bg = scene.add.image(-100, 0, 'graphics', 'char_select_bg_tile').setOrigin(0, 1);
      this._bg.mask = mask;
      this._bg2 = scene.add
        .image(this._bg.width + this._bg.x, 0, 'graphics', 'char_select_bg_tile')
        .setOrigin(0, 1);
      this._bg2.mask = mask;
      this.add([this._bg, this._bg2]);
    } else {
      this._bg = scene.add.image(0, 0, 'graphics', 'char_select_bg_tile_canvas').setOrigin(0.5, 1);
      this.add([this._bg]);
    }

    this._sprite.playAnimation(CharacterBase.ANIMATIONS.WALK, true);
    // this._sprite.setScale(0.75);
    scene.events.on('update', this.update, this);
  }

  get state() {
    return this._sprite.state;
  }

  update(time, delta) {
    delta /= 1000;
    if (this.maskImage) {
      this.maskImage.x = this.x;
      this.maskImage.y = this.y;

      if (this._sprite.isInState('demoWalk')) {
        this._bg.x -= delta * 100;
        this._bg2.x -= delta * 100;
        if (this._bg.x + this._bg.width < -100) this._bg.x = this._bg2.x + this._bg2.width;
        if (this._bg2.x + this._bg2.width < -100) this._bg2.x = this._bg.x + this._bg.width;
      }
    }

    this._sprite.x = this.x;
    this._sprite.y = this.y - 40;
    this._sprite.update(delta);
  }

  tiggerDemo(demo) {
    switch (demo) {
      case 'jump':
        this._sprite.demoJump();
        break;
      case 'attack':
        this._sprite.demoAttack();
        break;
      case 'idle':
        this._sprite.demoIdle();
        break;
      case 'walk':
        this._sprite.demoWalk();
        break;
      case 'special':
        this._sprite.demoSpecial();
        break;
      case 'pickup':
        this._sprite.demoPickup();
        break;
    }
    this.demo = demo;
  }

  destroy() {
    if (this._sprite.sprite && this._sprite.destroy) {
      this._sprite.destroy();
      this._sprite = null;
    }
    this.scene.events.off('update', this.update, this);
    super.destroy();
  }
}
